export default {"src":"/_next/static/media/darten.40d413b8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};